import { FunctionComponent } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Navigate } from 'react-router-dom'

import DocumentsListMobile from './documentsListMobile'
import { Document } from '../../../domain/documents.types'
import PlantSearchRedirect from '../../components/plantSearchRedirect/plantSearchRedirect'
import { DASHBOARD_URL } from '../../../constants/navigation.constants'
import { DocumentWrapper, CenterWrapper, DocumentList } from './documents.styles'
import { DocumentHeader } from './documentHeader'
import { useDocumments } from './documents.hook'
import DocumentsTable from '../../components/documentsTable/documents.table'
import useDocumentsTablesColumnsHelper from './documents.tables.columns.helper'

const Documents: FunctionComponent = () => {
  const {
    t,
    userAccessState,
    isMobile,
    currentConfig,
    filters,
    wrapperRef,
    selectedPlant,
    selectedItems,
    categorySortVisible,
    categoryFilterVisible,
    downloadMultipleFiles,
    multipleDownloadLoading,
    requestSort,
    handleCategorySelect,
    documentsLoading,
    documents,
    sortedItems,
    handleSelectItem,
    documentsError,
    setCategorySortVisible,
    fetchBlob,
    downloadSingleFile,
    headers,
    isDownloading,
    setIsDownloading,
  } = useDocumments()

  const columns = useDocumentsTablesColumnsHelper()

  return (
    <>
      {!userAccessState?.documentPage ? (
        <Navigate to={DASHBOARD_URL} />
      ) : (
        <DocumentWrapper>
          {!isMobile && <PlantSearchRedirect />}
          <DocumentHeader
            currentConfig={currentConfig}
            headers={headers}
            filters={filters}
            wrapperRef={wrapperRef}
            selectedPlant={selectedPlant}
            selectedItems={selectedItems}
            categorySortVisible={categorySortVisible}
            categoryFilterVisible={categoryFilterVisible}
            setCategorySortVisible={setCategorySortVisible}
            downloadMultipleFiles={downloadMultipleFiles}
            downloadMultipleIsLoading={multipleDownloadLoading}
            requestSort={requestSort}
            handleCategorySelect={handleCategorySelect}
          />
          {documentsLoading && (
            <CenterWrapper>
              <FontAwesomeIcon icon="spinner" spin size="lg" />
              <p>{`${t('collect_your_documents')}...`}</p>
            </CenterWrapper>
          )}
          {!documentsLoading && documents && (
            <DocumentList>
              {isMobile ? (
                <DocumentsListMobile
                  documentsList={sortedItems as Document[]}
                  filters={filters}
                  handleSelectItem={handleSelectItem}
                  selectedItems={selectedItems as Document[]}
                />
              ) : (
                <>
                  <DocumentsTable
                    data={documents}
                    columns={columns}
                    viewFunction={fetchBlob}
                    downloadFunction={downloadSingleFile}
                    downloadMultipleFunction={downloadMultipleFiles}
                    isDownloading={isDownloading}
                    setIsDownloading={setIsDownloading}
                  />
                </>
              )}
            </DocumentList>
          )}
          {!documentsLoading && documents?.length === 0 && documentsError && (
            <CenterWrapper>
              <FontAwesomeIcon icon="exclamation-triangle" size="lg" />
              <p>{t('error_collect_your_documents')}</p>
            </CenterWrapper>
          )}
        </DocumentWrapper>
      )}
    </>
  )
}

export default Documents
